<div class="auth-wrapper">
  <div class="auth-card">
    <div class="auth-logo">
      <img
        src="assets/img/entrustedLogoBlack.png"
        alt="branding logo"
        />
    </div>

    <h1 class="auth-title">Forgot Password</h1>
    <p class="auth-subtitle">Enter your email to receive a reset link</p>

    @if (successMessage) {
      <div class="alert alert-success">
        {{ successMessage }}
      </div>
    }
    @if (errorMessage) {
      <div class="alert alert-danger">
        {{ errorMessage }}
      </div>
    }

    <form
      class="form-horizontal form-simple"
      #forgotPasswordForm="ngForm"
      (ngSubmit)="onSubmit()"
      novalidate
      >
      <div class="form-group">
        <label for="email" class="d-none">Email</label>
        <input
          type="email"
          name="email"
          [(ngModel)]="model.email"
          class="form-control"
          id="email"
          placeholder="Enter Email"
          required
          autocomplete="email"
          />
      </div>

      <button
        type="submit"
        class="btn btn-success"
        [disabled]="forgotPasswordForm.invalid || clicked === true"
        >
        {{ clicked ? "Submitting..." : "Submit" }}
      </button>
    </form>

    <div class="auth-footer">
      <a routerLink="/login">Back to sign in</a>
    </div>
  </div>
</div>
